import {AnyAction} from 'redux';
import Types from '../../actions/Types';

import BackgroundCategory from '../../../domain/entities/BackgroundCategory';

export default function reducer(
  state: {[key: number]: BackgroundCategory} = {},
  action: AnyAction,
): {[key: number]: BackgroundCategory} {
  switch (action.type) {
    case Types.IndexBackgroundCategoriesSuccess:
      return {
        ...state,
        ...action.payload.records.reduceRight(
          (
            obj: {[key: number]: BackgroundCategory},
            record: BackgroundCategory,
          ) => {
            obj[record.id] = record;
            return obj;
          },
          {},
        ),
      };
    case Types.ShowBackgroundCategorySuccess:
      return {
        ...state,
        [action.payload.id]: action.payload,
      };
    default:
      return state;
  }
}
